function initializeValdrop() { // need drop.js
    // console.log('start fe-calc');
    if($('.valdrop')[0]){
        $(document).on('click', '.drop .srch', (e)=> $(this) && e.stopPropagation());
        // $('#inVal').on('change keyup', ()=> mainFeeCalc());
        // if ($('#srvl')[0]) {
        //     $('.drop').on('shown.bs.dropdown', ()=> $('#srvl').focus());
        //     $('#srvl').on('change keyup', ()=> sortVal($('#srvl').val()) );
        //
        // }

        if ($('.srvl')[0]) {
            $('.drop').on('shown.bs.dropdown', function () {

                $(this).find('.srvl').val('');
                console.log($(this));
                // console.log($(this).find('.srvl'));
                sortVal($(this), '');

                $(this).find('.srvl').focus().on('change keyup input', function (e) {
                    console.log($(this).val());
                    console.log(e);
                    sortVal($(this).parents('.drop'), $(this).val());
                });
            });

        }
        $('.drop .val').click( function (e) {
            $(this).parents('.drop').removeClass('open');

            let dv = $(this).attr('data-val');
            let dtxt = $(this).text();

            $(this).parents('.box-form').addClass('active').find('input').val(dv).on('update');

            if($(this).parents('.box-form').find('.ico')[0]) $(this).parents('.box-form').find('.toggle').html('<i class="ico ico-'+dv.toLowerCase()+'"></i>'+dv).removeClass('dd__Error');
            else $(this).parents('.box-form').find('.toggle').html(dtxt).removeClass('dd__Error');

            console.log(dv);

            if($(this).parents('#noOfUBOs')[0]) {

                let $uboVis = $('#uboVis'),
                    count = $('#noUBOs').val();

                $uboVis.html('');

                for (let i = 1;i<=count;i++) {
                    addUbos(i);
                }

                if($(window).width() > 1023) $('#uboVis .select select').select2();
                $('#uboVis .box-form select').on('focus input',function () {
                    $(this).parents('.box-form').addClass("active");
                });

                $('#uboVis .box-form select').on('blur',function () {
                    if($(this).val()==='' || $(this).val()===false) $(this).parents('.box-form').removeClass("active");
                });
            }

            if ($(this).parents('#businessFormDropDown')[0]) {
                // console.log('businessFormDropDown');
                let $dataField = $('[data-field]');
                $dataField.addClass('hide').find('input').removeAttr('required').find('textarea').removeAttr('required');
                $dataField.find('textarea').removeAttr('required');

                if(dv === 'B2B online business' || dv === 'Online gaming') {
                    opIndChange($('[data-field="f1"]'));
                    opIndChange($('[data-field="f8"]'));

                } else if(dv === 'Crypto exchanges/brokers' || dv === 'Financial services') {
                    opIndChange($('[data-field="f1"]'));

                } else if(dv === 'Other') {
                    opIndChange($('[data-field="f3"]'));
                    opIndChange($('[data-field="f8"]'));
                }

                opIndChange($('[data-field="f2"]'));
                opIndChange($('[data-field="f4"]'));
                opIndChange($('[data-field="f5"]'));
                opIndChange($('[data-field="f6"]'));
                opIndChange($('[data-field="f7"]'));
            }

            // if ($(this).parents('.conv-form')[0]) obmen();

            function opIndChange(t) {

                t.removeClass('hide').find('input').attr('required',true);
                t.find('textarea').attr('required',true);
            }

            // mainFeeCalc();
        })


        function sortVal(p,z){
            let mass = p.find('.val');

            mass.addClass('hide');
            // console.log(p);
            // console.log(z);
            for(let i=0;i<mass.length;i++){

                let str = $(mass[i]).data('val'), reg = new RegExp(z, 'i');
                if(reg.test(str)) mass[i].classList.remove("hide");
            }
        }
    }

};